import {DialogTitle, IconButton} from "@mui/material";
import Iconify from "./Iconify";

export default function BootstrapDialogTitle (props) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <Iconify icon="akar-icons:cross" />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};